import { render, staticRenderFns } from "./RelatedGuestsAlert.vue?vue&type=template&id=019149d3&"
import script from "./RelatedGuestsAlert.vue?vue&type=script&lang=ts&"
export * from "./RelatedGuestsAlert.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports